import React, { useEffect } from 'react';
import ProductCard from "../ProductCard";
import { Link, useLocation } from "react-router-dom";

const ShopList = React.memo(({ products = [], categories = [], brands = [], badge, currentPage, totalPages, totalCount, brand, child_category }) => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const category = query.get('category');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const getTitle = (key, list) => {
        const item = list.find(item => item.sku === key || item.permalink === key);
        return item ? item.title : key;
    };

    const getChildCategoryTitle = (key, categories) => {
        for (let category of categories) {
            if (category.child_categories) {
                const childCategory = category.child_categories.find(child => child.child_sku === key);
                if (childCategory) {
                    return childCategory.child_title;
                }
            }
        }
        return key;
    };

    const categoryTitle = getTitle(category, categories);
    const childCategoryTitle = getChildCategoryTitle(child_category, categories);
    const brandTitle = getTitle(brand, brands);

    const buildLink = (pageNumber) => {
        let link = `?page=${pageNumber}`;
        if (category) link += `&category=${category}`;
        if (child_category) link += `&child_category=${child_category}`;
        if (brand) link += `&brand=${brand}`;
        return link;
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const maxPagesToShow = 5;
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

        if (endPage - startPage < maxPagesToShow - 1) {
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }

        if (startPage > 1) {
            pageNumbers.push(
                <li key={1} className={`page-item ${parseInt(currentPage) === 1 ? 'active' : ''}`}>
                    <Link className="search-result-pag-btn" to={buildLink(1)}>1</Link>
                </li>
            );
            if (startPage > 2) {
                pageNumbers.push(
                    <li key="ellipsis-start" className="page-item disabled">
                        <span className="search-result-pag-btn">...</span>
                    </li>
                );
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <li key={i} className={`page-item ${i === parseInt(currentPage) ? 'active' : ''}`}>
                    <Link className="search-result-pag-btn" to={buildLink(i)}>{i}</Link>
                </li>
            );
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pageNumbers.push(
                    <li key="ellipsis-end" className="page-item disabled">
                        <span className="search-result-pag-btn">...</span>
                    </li>
                );
            }
            pageNumbers.push(
                <li key={totalPages} className={`page-item ${totalPages === parseInt(currentPage) ? 'active' : ''}`}>
                    <Link className="search-result-pag-btn" to={buildLink(totalPages)}>{totalPages}</Link>
                </li>
            );
        }

        return pageNumbers;
    };

    return (
        <>
            <div className="sortbar flex-wrap align-items-center">
                <h3 className='d-block m-0' dangerouslySetInnerHTML={{ __html: categoryTitle || childCategoryTitle || brandTitle ? `Search Results for <span>${categoryTitle ? `"${categoryTitle}"` : ''} ${childCategoryTitle ? ` "${childCategoryTitle}"` : ''} ${brandTitle ? ` "${brandTitle}"` : ''}</span>` : '' }} />
                <p className='d-block'>There are {totalCount} products.</p>
            </div>

            {products.length === 0 ? (
                <p className='text-center'>No Product Found</p>
            ) : (
                <div className="shop-product-list d-flex justify-content-start flex-wrap flex-wrap gap-3">
                    {products.slice(0, 15).map((product) => (
                        <ProductCard
                            key={product.id}
                            product={product}
                            categories={categories}
                            badge={badge}
                            className="shop-product"
                        />
                    ))}
                </div>
            )}

            {totalCount > 16 && (
                <nav aria-label="Page navigation example">
                    <ul className="pagination mt-3 justify-content-md-end justify-content-center">
                        {renderPageNumbers()}
                    </ul>
                </nav>
            )}

            <div className='shop-privacy-text d-none'>
                <p>
                    It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.
                </p>
                <ul>
                    <li>Various versions have evolved over the years, sometimes by accident</li>
                    <li>Sometimes on purpose (injected humour and the like).</li>
                    <li>Contrary to popular belief, Lorem Ipsum is not simply random text.</li>
                    <li>It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</li>
                </ul>
                <p>Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections</p>
            </div>
        </>
    );
});

export default ShopList;